import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import common from './common/function';
import 'swiper/swiper-bundle.css';
import store from './store';
import VueI18n from 'vue-i18n';
import 'video.js/dist/video-js.css';

Vue.prototype.$http = http;
Vue.prototype.common = common;
Vue.config.productionTip = false;

Vue.use(VueAwesomeSwiper);
Vue.use(Vant);
Vue.prototype.$toast = createMarkedToast(Vue.prototype.$toast);
Vue.use(VueI18n);

const messages = {
  en_us: require('./assets/languages/en_us.json'),
  yn_yu: require('./assets/languages/yn_yu.json'),
  zh_cn: require('./assets/languages/zh_cn.json'),
  es_spa: require('./assets/languages/es_spa.json'),
  ms_my: require('./assets/languages/ms_my.json')
};

function getValidLocale() {
  const rawLang = (localStorage.getItem('lang') || 'en_us').toLowerCase();

  const langMap = {
    en: 'en_us',
    'en-us': 'en_us',
    en_us: 'en_us',

    zh: 'zh_cn',
    'zh-cn': 'zh_cn',
    zh_cn: 'zh_cn',

    es: 'es_spa',
    'es-es': 'es_spa',
    es_spa: 'es_spa',
    tr: 'es_spa',
    'tr-tr': 'es_spa',

    ms: 'ms_my',
    'ms-my': 'ms_my',
    ms_my: 'ms_my',

    yn_yu: 'yn_yu'
  };

  const locale = langMap[rawLang] || 'en_us';
  localStorage.setItem('lang', locale);
  return locale;
}

const i18n = new VueI18n({
  locale: getValidLocale(),
  fallbackLocale: 'en_us',
  messages
});

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');

function createMarkedToast(rawToast) {
  function cleanMessage(message) {
    if (message == null) {
      return message;
    }
    return String(message).replace(/\s*[!！]+\s*$/g, '');
  }

  function show(options, type) {
    if (typeof options === 'string' || typeof options === 'number') {
      return rawToast({
        type: type || 'text',
        position: 'middle',
        duration: 1600,
        message: cleanMessage(options)
      });
    }
    if (options && typeof options === 'object') {
      const next = Object.assign({}, options);
      if (type) {
        next.type = type;
      }
      if (next.message != null && next.type !== 'loading') {
        next.message = cleanMessage(next.message);
      }
      if (next.type !== 'loading') {
        if (!next.position) {
          next.position = 'middle';
        }
        if (next.duration == null) {
          next.duration = 1600;
        }
      }
      return rawToast(next);
    }
    return rawToast(options);
  }

  function toast(options) {
    return show(options);
  }

  toast.success = function(options) {
    return show(options, 'success');
  };
  toast.fail = function(options) {
    return show(options, 'fail');
  };
  toast.loading = function(options) {
    return rawToast.loading(options);
  };
  toast.clear = function(clearAll) {
    return rawToast.clear(clearAll);
  };
  toast.allowMultiple = function() {
    return rawToast.allowMultiple();
  };
  toast.setDefaultOptions = function() {
    return rawToast.setDefaultOptions.apply(rawToast, arguments);
  };
  toast.resetDefaultOptions = function() {
    return rawToast.resetDefaultOptions.apply(rawToast, arguments);
  };

  return toast;
}
